// eslint-disable-next-line no-restricted-imports
import { useFlags } from 'launchdarkly-react-client-sdk';

/**
 * Flags that are permanent and not subject to change.
 *
 * If you need are adding a temporary flag, add it to `useTemporaryFlags` instead.
 */
export type FeatureFlags = {
  deletionRecovery: boolean;
  libraries: boolean;
  hideShortUrlSignUpButton: string[];
  showUnnamedPeople: boolean;
  whiteLabelWorkspaces?: string[];
  enableSaml: boolean;
};

export const useFeatureFlags = () => useFlags<FeatureFlags>();
